import * as React from 'react';
import {
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import {useSnackbar} from 'notistack';

import {getEnum} from '../api';
import {EnumContextValue, FieldTypeResponseDto} from '../models';
import {useAuth} from './auth';

const initialFieldTypes = new Map();

export const EnumContext = React.createContext<EnumContextValue>({
  fieldTypes: initialFieldTypes,
});

export const useEnum = () => useContext(EnumContext);

export const EnumProvider: React.FC<PropsWithChildren> = ({children}) => {
  const {token} = useAuth();
  const {enqueueSnackbar} = useSnackbar();
  const [fieldTypes, setFieldTypes] =
    useState<Map<string, FieldTypeResponseDto>>(initialFieldTypes);

  //Boolean Felder werden vom Endpunkt nicht korrekt zurückgegeben
  const cleanFieldInfo = data => {
    const newData = {...data};
    Object.keys(newData).forEach(imiItem => {
      if (newData[imiItem].format === 'BOOLEAN') {
        newData[imiItem].values = ['TRUE', 'FALSE'];
      }
    });

    return newData;
  };

  // Load enums once on mount
  useEffect(() => {
    getEnum(token, enqueueSnackbar, 'fieldTypes', data => {
      data = cleanFieldInfo(data);
      setFieldTypes(new Map(Object.entries(data)));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(
    () => ({
      fieldTypes,
    }),
    [fieldTypes],
  );
  return <EnumContext.Provider value={value}>{children}</EnumContext.Provider>;
};
